// extracted by mini-css-extract-plugin
export default {"screen-content":"AdministrationRoleNewScreen_screen-content__dSpcB"};